import { setPanelContent, getShadowRoot, setFabPulse } from "../../ui/container";
import type { Locale } from "../../types";

var textWs: WebSocket | null = null;
var chatMessages: Array<{ role: "user" | "agent" | "_typing_"; text: string }> = [];
var storedReceptionistId: number | null = null;
var storedReceptionistName = "AI 助手";
var storedWidgetId = "";
var onBackToHome: (() => void) | null = null;
// API base URL, shared across functions
var apiBaseUrl = (typeof window !== "undefined" && (window as any).__oc_apiBase__) ? (window as any).__oc_apiBase__ : location.origin + "/api";

function getVisitorKey(): string {
  try { var k = localStorage.getItem("oc_visitor_key"); if (k) return k; } catch (e) {}
  var key = "v_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8);
  try { localStorage.setItem("oc_visitor_key", key); } catch (e) {}
  return key;
}

function saveMessage(role: "user" | "agent", text: string): void {
  try {
    fetch(apiBaseUrl + "/widget/conversation-message", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        widgetId: storedWidgetId,
        receptionistId: storedReceptionistId,
        visitorName: getVisitorKey(),
        message: text,
        senderType: role === "user" ? "visitor" : "agent",
        isStaff: 0,
      }),
    }).catch(function() { /* silent fail */ });
  } catch (e) { /* silent */ }
}

var storedTextChatWelcome = "你好，有什么可以帮你的？";
var storedQuickReplies: string[] = [];

export function renderTextChatPanel(
  _locale: Locale, widgetId: string,
  receptionistId?: number | null, receptionistName?: string | null,
  onBack?: () => void,
  textChatWelcome?: string,
  quickReplies?: string[],
): void {
  chatMessages = [];
  storedReceptionistId = receptionistId || null;
  storedReceptionistName = receptionistName || "AI 助手";
  storedWidgetId = widgetId || "";
  onBackToHome = onBack || null;
  storedTextChatWelcome = textChatWelcome || "你好，有什么可以帮你的？";
  storedQuickReplies = quickReplies || [];
  setFabPulse(false);
  if (textWs) { textWs.close(); textWs = null; }
  if (storedTextChatWelcome) {
    chatMessages.push({ role: "agent", text: storedTextChatWelcome });
  }
  setPanelContent(buildHTML());
  bindEvents();
  refreshMessages();
}

function c(): string {
  try { var r = getShadowRoot(); if (r) { var v = getComputedStyle(r.host).getPropertyValue("--oc-primary").trim(); if (v) return v; } } catch (e) {}
  return "#533afd";
}

function buildHTML(): string {
  var col = c();
  var quickRepliesHTML = "";
  if (storedQuickReplies && storedQuickReplies.length > 0) {
    quickRepliesHTML = '<div class="tc-quick-replies">' +
      storedQuickReplies.map(function(r) {
        return '<button class="tc-qr-btn" data-reply="' + esc(r) + '">' + esc(r) + '</button>';
      }).join("") +
      '</div>';
  }
  return '<style>' +
    '.tc-quick-replies{display:flex;flex-wrap:wrap;gap:4px;padding:0 0 6px 0;}' +
    '.tc-qr-btn{padding:3px 10px;border:1px solid ' + col + ';border-radius:14px;background:#fff;color:' + col + ';font-size:11px;cursor:pointer;transition:all 0.15s;white-space:nowrap;}' +
    '.tc-qr-btn:hover{background:' + col + ';color:#fff;}' +
    '.tc-typing-dots{display:flex;gap:4px;align-items:center;padding:8px 14px;background:#f1f5f9;border-radius:14px;}' +
    '.tc-typing-dots span{width:6px;height:6px;border-radius:50%;background:#94a3b8;animation:tc-dot-bounce 1.4s ease-in-out infinite;}' +
    '.tc-typing-dots span:nth-child(2){animation-delay:0.2s;}' +
    '.tc-typing-dots span:nth-child(3){animation-delay:0.4s;}' +
    '@keyframes tc-dot-bounce{0%,80%,100%{transform:scale(0.6);opacity:0.4;}40%{transform:scale(1);opacity:1;}}' +
  '</style>' +
    '<div class="tc-root" id="tc-root">' +
    '<div class="tc-body" id="tc-body"><div id="tc-messages"></div></div>' +
    '<div class="tc-footer">' + quickRepliesHTML +
      '<div class="tc-row-inp">' +
      '<input type="text" id="tc-input" class="tc-input" placeholder="输入你的问题…" autofocus />' +
      '<button id="tc-send" class="tc-send" style="background:' + col + '" title="发送"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button>' +
    '</div></div></div>';
}

function refreshMessages(): void {
  var el = getShadowRoot()?.getElementById("tc-messages"); if (!el) return;
  el.innerHTML = chatMessages.map(function(m) {
    if (m.role === "_typing_") {
      return '<div class="tc-row agent"><div class="tc-av agent-av"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 00-16 0"/></svg></div><div class="tc-typing-dots"><span></span><span></span><span></span></div></div>';
    }
    var isUser = m.role === "user";
    var av = isUser ? '<div class="tc-av user-av">&#x1F464;</div>' : '<div class="tc-av agent-av"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 00-16 0"/></svg></div>';
    return '<div class="tc-row ' + (isUser ? "user" : "agent") + '">' + (isUser ? '<div class="tc-bubble">' + esc(m.text) + '</div>' + av : av + '<div class="tc-bubble">' + esc(m.text) + '</div>') + '</div>';
  }).join("");
  var body = getShadowRoot()?.getElementById("tc-body"); if (body) body.scrollTop = body.scrollHeight;
}

function esc(s: string): string { if (!s) return ""; return s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }

function connect(): void {
  var lastCheck = "";
  (window as any).__oc_chatState__ = { disableAutoReply: false };

  var pollStaff = function() {
    var url = apiBaseUrl + "/widget/" + encodeURIComponent(storedWidgetId) + "/staff-messages";
    if (lastCheck) url += "?since=" + encodeURIComponent(lastCheck);
    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        (window as any).__oc_chatState__.disableAutoReply = !!(typeof data.disableAutoReply === "boolean" && data.disableAutoReply);
        if (data.messages && data.messages.length) {
          for (var i = 0; i < data.messages.length; i++) {
            var m = data.messages[i];
            var dup = false;
            for (var k = chatMessages.length - 1; k >= 0; k--) {
              if (chatMessages[k].role === "agent" && chatMessages[k].text === m.content) { dup = true; break; }
            }
            if (!dup) chatMessages.push({ role: "agent", text: m.content });
          }
          lastCheck = data.messages[data.messages.length - 1].created_at;
          refreshMessages();
        }
      }).catch(function() { /* ignore */ });
  };

  pollStaff();
  setInterval(pollStaff, 3000);

  var overridden = (window as any).__ONECALL_VOICE_WS__;
  var hostname = location.hostname;
  var wsUrl = overridden || (hostname === "localhost" || hostname === "127.0.0.1" ? "ws://127.0.0.1:8765/ws" : (location.protocol === "https:" ? "wss:" : "ws:") + "//" + location.host + "/ws");
  var reconnectAttempts = 0;
  var MAX_RECONNECT = 3;
  function doConnect() {
    textWs = new WebSocket(wsUrl);
    textWs.onopen = function() {
      reconnectAttempts = 0;
      textWs!.send(JSON.stringify({ provider: "text_chat", params: { receptionistId: storedReceptionistId || 1, from: "zh", to: "zh" } }));
    };
    textWs.onmessage = function(event) { if (typeof event.data !== "string") return; try { var msg = JSON.parse(event.data); if (msg.type === "assistant_text" && msg.text) { removeLoading(); chatMessages.push({ role: "agent", text: msg.text }); saveMessage("agent", msg.text); refreshMessages(); } } catch (e) {} };
    textWs.onclose = function() {
      if (reconnectAttempts < MAX_RECONNECT) {
        reconnectAttempts++;
        setTimeout(doConnect, 2000 * reconnectAttempts);
      }
    };
  }
  doConnect();
}

var _loadingTimer: any = null;

function removeLoading(): void {
  if (_loadingTimer) { clearTimeout(_loadingTimer); _loadingTimer = null; }
  chatMessages = chatMessages.filter(function(m) { return m.role !== "_typing_"; });
}

function showLoading(): void {
  removeLoading();
  chatMessages.push({ role: "_typing_", text: "" });
  refreshMessages();
  _loadingTimer = setTimeout(function() {
    removeLoading();
    refreshMessages();
  }, 15000);
}

function send(): void {
  var input = getShadowRoot()?.getElementById("tc-input") as HTMLInputElement;
  var text = input?.value?.trim();
  if (!text) return;
  chatMessages.push({ role: "user", text: text });
  refreshMessages();
  input.value = ""; input.focus();
  fetch(apiBaseUrl + "/widget/conversation-message", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      widgetId: storedWidgetId,
      receptionistId: storedReceptionistId,
      visitorName: getVisitorKey(),
      message: text,
      senderType: "visitor",
      isStaff: 0,
    }),
  }).then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.disableAutoReply) return;
    if (!textWs || textWs.readyState !== WebSocket.OPEN) {
      removeLoading();
      chatMessages.push({ role: "agent", text: "AI 助手暂未连接，客服稍后会回复您" });
      saveMessage("agent", "AI 助手暂未连接，客服稍后会回复您");
      refreshMessages();
      return;
    }
    showLoading();
    textWs.send(JSON.stringify({ type: "user_text", text: text }));
  }).catch(function() { /* 网络异常时静默失败 */ });
}

function bindEvents(): void {
  connect();
  var root = getShadowRoot(); if (!root) return;
  root.getElementById("tc-send")?.addEventListener("click", send);
  root.getElementById("tc-input")?.addEventListener("keydown", function(e) { if ((e as KeyboardEvent).key === "Enter") send(); });
  var qrBtns = root.querySelectorAll(".tc-qr-btn");
  qrBtns.forEach(function(btn) {
    btn.addEventListener("click", function() {
      var reply = (btn as HTMLElement).getAttribute("data-reply") || "";
      if (!reply) return;
      var input = root?.getElementById("tc-input") as HTMLInputElement;
      if (input) { input.value = reply; }
      send();
    });
  });
}

export function closeTextChat(): void { if (textWs) { textWs.close(); textWs = null; } chatMessages = []; removeLoading(); }
